import {fetchDelete, fetchPatch, fetchPost, generateEndpoint} from "../../../utils/request";

export const addUser = async({token, user, selectedRole}) => {
  const url = `${generateEndpoint("createUser")}`;
  return fetchPost(url, token, {
    name: user.name,
    email: user.email,
    role: selectedRole,
    organization: user.organization.id,
    permissions: user.permissions,
  });
};

export const updateUser = async({token, user}) => {
  const url = `${generateEndpoint("updateUser")}`;
  return fetchPatch(url, token, {user});
};

export const deleteUser = async({token, uid}) => {
  const url = `${generateEndpoint("deleteUser")}`;
  return fetchDelete(url, token, {uid});
};
